'use strict';

define('GetRelativeDayBasedOnGivenDateFilter',['DateTimeFormatters'],
    function (DateTimeFormatters) {
        return function () {
            return DateTimeFormatters.getRelativeDayBasedOnGivenDate;
        };
    });
